import { ApiClient } from "@/api-client/src/core/api-client";
import {
  Category,
  TopCategoryProductResponse,
  TopCategoryResponse,
} from "@/packages/types/category";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchCategoriesBySlug = async (
  slug: string
): Promise<Category> => {
  const response = await webService.get<Category>(`/categories/${slug}`);
  return response;
};
export const fetchTopCategories = async (): Promise<TopCategoryResponse> => {
  const response = await webService.get<TopCategoryResponse>(
    `/home-categories`
  );
  return response;
};
export const fetchTopProductCategories =
  async (): Promise<TopCategoryProductResponse> => {
    const response = await webService.get<TopCategoryProductResponse>(
      `/category-products`
    );
    return response;
  };
